module.exports = __webpack_public_path__ + "static/img/product-header-rj45.055577d0.jpg";